import { Box } from "@mui/material"
import { ReactElement } from "react"

interface IVideoProps {
    videoUrl?: string
}

/**
 * Video component to display a YouTube video passing the video ID
 * @param videoUrl - The video ID to display
 * */
const Video = ({ videoUrl }: IVideoProps): ReactElement => (
    <Box
        sx={{
            width: "100%",
            paddingTop: 3,
            display: "flex",
            justifyContent: "center",
        }}
    >
        <iframe
            width="560"
            height="315"
            src={`https://www.youtube-nocookie.com/embed/${videoUrl}`}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
            frameBorder={0}
        />
    </Box>
)

Video.defaultProps = {
    videoUrl: "",
}

export default Video
